import React from "react";
import { Users, Shield, Package, TrendingUp, Clock, CheckCircle, FileCheck, Loader2 } from "lucide-react";

export function OverviewStats({ stats, loading, pendingVerificationsCount }) {
  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <Loader2 className="w-8 h-8 animate-spin" />
      </div>
    );
  }

  if (!stats) return null;

  return (
    <div className="space-y-6">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          icon={Users}
          iconBg="bg-blue-100"
          iconColor="text-blue-600"
          label="Total Users"
          value={stats.users?.total_users || 0}
        />
        <StatCard
          icon={Shield}
          iconBg="bg-green-100"
          iconColor="text-green-600"
          label="Partners"
          value={stats.users?.total_partners || 0}
        />
        <StatCard
          icon={Package}
          iconBg="bg-purple-100"
          iconColor="text-purple-600"
          label="Total Bookings"
          value={stats.business?.total_bookings || 0}
        />
        <StatCard
          icon={TrendingUp}
          iconBg="bg-orange-100"
          iconColor="text-orange-600"
          label="Platform Revenue"
          value={`₹${(stats.business?.total_revenue || 0).toFixed(2)}`}
        />
      </div>

      {/* Secondary Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <SecondaryStatCard
          icon={Clock}
          iconColor="text-yellow-500"
          label="Pending Withdrawals"
          value={stats.withdrawals?.pending_count || 0}
          subValue={`₹${(stats.withdrawals?.pending_amount || 0).toFixed(2)}`}
        />
        <SecondaryStatCard
          icon={CheckCircle}
          iconColor="text-green-500"
          label="Completed Withdrawals"
          value={stats.withdrawals?.completed_count || 0}
          subValue={`₹${(stats.withdrawals?.total_processed || 0).toFixed(2)}`}
        />
        <SecondaryStatCard
          icon={FileCheck}
          iconColor="text-blue-500"
          label="Pending Verifications"
          value={pendingVerificationsCount}
          subValue="Partners awaiting review"
        />
      </div>
    </div>
  );
}

function StatCard({ icon: Icon, iconBg, iconColor, label, value }) {
  return (
    <div className="border border-border p-6">
      <div className="flex items-center gap-4">
        <div className={`w-12 h-12 ${iconBg} flex items-center justify-center`}>
          <Icon className={`w-6 h-6 ${iconColor}`} />
        </div>
        <div>
          <p className="text-sm text-muted-foreground">{label}</p>
          <p className="text-2xl font-black">{value}</p>
        </div>
      </div>
    </div>
  );
}

function SecondaryStatCard({ icon: Icon, iconColor, label, value, subValue }) {
  return (
    <div className="border border-border p-6">
      <div className="flex items-center gap-3 mb-2">
        <Icon className={`w-5 h-5 ${iconColor}`} />
        <span className="font-semibold">{label}</span>
      </div>
      <p className="text-2xl font-black">{value}</p>
      <p className="text-sm text-muted-foreground">{subValue}</p>
    </div>
  );
}
